import Extension from '@/tiptap/tiptap/Utils/Extension';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { Plugin, PluginKey } from 'prosemirror-state';

// matches the animation of .m-editor-fresh-text; a range is dropped once it has fully faded in
const FRESH_TEXT_FADE_MS = 400;

const key = new PluginKey('fresh-text-fade');

// A streamed answer replaces the whole document on every update, so what is new is found by
// diffing against the previous document rather than by mapping the transaction.
export default class FreshTextFade extends Extension {
  get name() {
    return 'fresh-text-fade';
  }

  get plugins() {
    return [
      new Plugin({
        key,
        state: {
          init: () => [],
          apply: (tr, ranges, oldState, newState) => {
            if (!tr.docChanged) {
              return ranges;
            }
            const start = newState.doc.content.findDiffStart(oldState.doc.content);
            if (start === null) {
              return ranges;
            }
            const now = Date.now();
            const kept = ranges
              .filter((range) => range.from < start && now - range.at < FRESH_TEXT_FADE_MS)
              .map((range) => ({ ...range, to: Math.min(range.to, start) }));
            return [...kept, { from: start, to: newState.doc.content.size, at: now }];
          },
        },
        props: {
          decorations: (state) => DecorationSet.create(
            state.doc,
            key.getState(state).map(({ from, to }) => Decoration.inline(from, to, { class: 'm-editor-fresh-text' })),
          ),
        },
      }),
    ];
  }
}
